import { FC } from 'react';
import cn from 'classnames';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import { UserDetailsDto } from '../../../store/contextAPI/user/dto/response/user-details.dto';
import { UserManagementUsersEditTemplate } from '../index';
import { UserManagementUsersDetailsForm } from '../../organisms';
import styles from './UserManagementUsersEditDetailsTemplate.module.css';

export interface UserManagementUsersEditDetailsTemplateProps {
  data: UserDetailsDto;
  handleOnChange: (user: UserDetailsDto) => void;
  callbackFn: (user: UserDetailsDto) => void;
}

const UserManagementUsersEditDetailsTemplate: FC<
  UserManagementUsersEditDetailsTemplateProps
> = ({ data, handleOnChange, callbackFn }) => {
  return (
    <BaseTemplate>
      <Container>
        <UserManagementUsersEditTemplate>
          <div className={cn(styles.formWrapper)}>
            <UserManagementUsersDetailsForm
              data={data}
              handleOnChange={handleOnChange}
              callbackFn={callbackFn}
            />
          </div>
        </UserManagementUsersEditTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default UserManagementUsersEditDetailsTemplate;
